import React, { createContext, useContext, useEffect, useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { useCloudAccount } from '../account/CloudAccountGate';
import { feedbackApi } from './api';
import { FeedbackDialog } from './FeedbackDialog';
import './feedback.css';

const FeedbackContext = createContext({ enabled: false });
export const useFeedback = () => useContext(FeedbackContext);

export const FeedbackProvider = ({ children }) => {
  const { runtimeMode } = useCloudAccount();
  const [account, setAccount] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let active = true;
    setAccount(null);
    if (runtimeMode === 'cloud') feedbackApi.context()
      .then(({ data }) => { if (active) setAccount(data); })
      .catch(() => { if (active) setAccount(null); });
    return () => { active = false; };
  }, [runtimeMode]);
  const enabled = runtimeMode === 'cloud' && account?.enabled === true;
  return <FeedbackContext.Provider value={{ ...account, enabled, openFeedback: () => setOpen(true) }}>
    {children}
    {enabled && <FeedbackDialog open={open} onOpenChange={setOpen} account={account} />}
  </FeedbackContext.Provider>;
};

export const FeedbackTrigger = ({ fullLabel = false }) => {
  const { enabled, openFeedback } = useFeedback();
  if (!enabled) return null;
  return <button type="button" data-testid="feedback-trigger-btn" onClick={openFeedback}
    className="feedback-trigger" title="Санал хүсэлт" aria-label="Санал хүсэлт">
    <MessageSquare size={18} aria-hidden="true" />
    <span className={fullLabel ? '' : 'hidden sm:inline'}>Санал хүсэлт</span>
  </button>;
};